module.exports = __webpack_public_path__ + "static/92efc885.circle.png";